// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__2yY2a global_fake-popup-border__W98Md","closeBtn":"About_closeBtn__3Q4MQ"};